<template>
  <div data-type="layout">
  	<swiper id="swiper-plastickill" :options="swiperOption" ref="problemsPlasticKills" class="span-swiper span-swiper-full span-full full-transitions bgorange">
      <swiper-slide>
      	<div class="full-inner">
  	      <h2 class="full-title content-650">{{title}}</h2>
      	</div>
      </swiper-slide>
      <swiper-slide v-if="item.title" v-for="(item,key) in slider">
      	<div class="full-inner">
      		<div class="span-table text-left">
    				<div class="item">
    					<div class="content-650">
  	  					<h2 class="full-title">{{item.title}}</h2>
  	  					<div class="entry-content pt1 content-500 left" v-html="item.content"></div>
    					</div>
    				</div>
    				<div class="item item-image full-image">
              <img v-bind:class="'plastickills-'+key" v-bind:src="'/static/images/whyplastic-slider-'+key+'.png'" alt="" class="icon-slider">
            </div>
      		</div>
      	</div>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
    <a href="#" data-index="2" class="read-more">
      <span class="arrow-down"></span>
    </a>
  </div>
</template>
<script>
	import misc from '../js/scripts.js'
	export default {
		name: 'problems-plastickill',
		data() {
	    return {
        title: '',
        slider: {},
	      swiperOption: {
          notNextTick: true,
          loop:true,
          updateTranslate: true,
          direction : 'horizontal',
          prevButton:'.swiper-button-prev',
          nextButton:'.swiper-button-next',
          observeParents:true,
          debugger: true,
          speed: 600,
          autoplay: 0,
          paginationClickable :false,
          onSlideChangeStart(s){
            if( 'ontouchstart' in window || navigator.maxTouchPoints || misc.get_viewport().width < 560 ){
              var activeSlideHeight = s.slides[s.activeIndex].querySelector('.full-inner').getBoundingClientRect().height + 'px';
              s.container[0].style.height = activeSlideHeight
            }
          }
  	    }
      }
	  },
	  computed: {
	    swiper() {
	      return this.$refs.problemsPlasticKills.swiper
	    }
	  },
    methods: {
      getUrl(){
        if( localStorage.getItem('language') === 'en' ){
          return process.env.site.url + '/wp-json/wp/v2/pages?slug=problems-why-plastic-kills'
        } else {
          return process.env.site.url + '/wp-json/wp/v2/pages?slug=problemas-porque-el-plastico-mata&lang=es'
        }
      },
      loadContent(){
        var getUrl = this.getUrl()
        this.axios.get(this.getUrl()).then((response) => {
          var page = response.data[0]
          this.title = page.acf.title
          this.slider = page.acf.slider
          misc.addArrows()
        })
      }
    },
    watch: {
      '$route': 'loadContent'
    },
    mounted(){
      this.loadContent()
    },
	}
</script>


// WEBPACK FOOTER //
// Problems-plastickill.vue?0f9721c8